import React,{useEffect, useState} from 'react';

import project1 from "../../Images/product1.png";
import project2 from "../../Images/product2.png";

export default function Work(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);

        return () =>window.removeEventListener("scroll", handleScroll);
    },[])

    return(
        <div className="Product">
            <div className="work-intro" data-aos="fade-right">
                <h2 className="work-Title">Aiding makers & creators all over the world.</h2>
                <p className="work-slogan">A few products I've built for young developers and efficient workflows.</p>
            </div>
            {media.matches && (
                <div>
            <div className="portfolio">
                <a href="https://gumroad.com/l/jzjEk">
                    <div className="project-div blog-div"  data-aos="fade-up">
                        <div className="project-img blog-img">
                            <img src={project1} className="blogimg" />
                        </div>
                        <div className="project-des blog-des" >
                            <div>
                                <h3 className="des-head blog-head">Personal Blogs/Posts Web App.</h3>
                                <p className="blog-para">Built with Laravel & React</p>
                            </div>
                            <div className="price">$15+</div>
                        </div>
                    </div>
                </a>
                <a href="https://gumroad.com/l/EByFU">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project2} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">Mockups - Showcase your work.</h3>
                            <p className="blog-para">Adobe XD</p>
                        </div>
                        <div className="price">$0+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="social-footer" data-aos="fade-up">
                <a href="https://buymeacoffee.com/vikalp"><button className="social-btn coffee">Buy me a coffee ☕</button></a>
            </div>
            </div>
            )}
            {!media.matches && (
                <div>
            <div className="portfolio">
                
                    <div className="project-div blog-div">
                        <div className="project-img blog-img">
                            <img src={project1} className="blogimg" />
                        </div>
                        <div className="project-des blog-des" >
                            <div>
                            <a href="https://gumroad.com/l/jzjEk">
                                <h3 className="des-head blog-head">Personal Blogs/Posts Web App.</h3>
                                </a>
                                <p className="blog-para">Built with Laravel & React</p>
                            </div>
                            <div className="price">$15+</div>
                        </div>
                    </div>
                
                    <div Class="project-div blog-div">
                        <div className="project-img blog-img">
                            <img src={project2} className="blogimg" />
                        </div>
                        <div className="project-des blog-des">
                            <div>
                            <a href="https://gumroad.com/l/EByFU">
                                <h3 className="des-head blog-head">Mockups - Showcase your work.</h3>
                               </a>
                                <p className="blog-para">Adobe XD</p>
                            </div>
                            <div className="price">$0+</div>
                        </div>
                    </div>
            </div>
            <div className="social-footer">
                <a href="https://buymeacoffee.com/vikalp"><button className="social-btn coffee">Buy me a coffee ☕</button></a>
            </div>
            </div>
            )}
        </div>
    )
}